export default __webpack_public_path__ + "static/media/VeggieFruit_09.33c413d1.png";